// src/components/intake/IntakeBeckham.js
//
// Ticket 064 (screen 2.5). Beckham regime, Yes / No for everyone. Labels and
// values come from BECKHAM_STATUS_OPTIONS ('active' is Yes). No "Not sure".

import React from 'react'
import IntakeOptionButton from './IntakeOptionButton'
import { BECKHAM_STATUS_OPTIONS, BECKHAM_YES_NOTICE } from '../../lib/intake/intakeConfig'

export default function IntakeBeckham({ value, onChange }) {
  return (
    <div className="u-stack-sm">
      <div className="u-stack-xs">
        {BECKHAM_STATUS_OPTIONS.map((o) => (
          <IntakeOptionButton key={o.value} label={o.label} selected={value === o.value} onClick={() => onChange(o.value)} />
        ))}
      </div>
      {value === 'active' && <p className="intake-notice">{BECKHAM_YES_NOTICE}</p>}
    </div>
  )
}
